import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudInputTextModule,
	FreudLoaderModule,
	FreudTooltipModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'shared/shared.module';

import { PromptuaryTaskComponent } from './promptuary-task.component';

@NgModule({
	declarations: [PromptuaryTaskComponent],
	imports: [
		CommonModule,
		TranslateModule,
		FreudTooltipModule,
		FreudDialogModule,
		SharedModule,
		FreudInputTextModule,
		FreudButtonModule,
		FormsModule,
		ReactiveFormsModule,
		FreudLoaderModule,
	],
	exports: [PromptuaryTaskComponent],
	providers: [],
})
export class PromptuaryTaskModule {}
